<!-- 广告详情 -->
<template>
  <div class="advertisement-details-page" id="AdvertisementDetails">
    <div class="cts">
      <div class="title text-left">
        <p class="fontsize-24 c262833">
          {{ infoData.activityName }}
        </p>
        <p class="fontsize-1 c91929B time">{{ infoData.lastModifiedDate }}</p>
      </div>
      <div class="adText">
        <div class="word-wrap" style="white-space:pre-wrap" v-html="infoData.adText ? infoData.adText : ''"></div>
      </div>
    </div>
  </div>
</template>

<script>
import getUserMethods from "utils/getUserMethods";
import { formatDate, } from "utils/mUtils";

export default {
  mixins: [getUserMethods], // mixins混入策略
  data() {
    return {
      api_advertising_info: '/advertising/info', // 广告详情
      infoData: {},
    };
  },
  computed: {
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    // 浏览器高度
    document.getElementById("AdvertisementDetails").style.height =
      this.windowHeight + "px";
  },
  methods: {
    // 获取详情
    getDetail() {
      let params = {
        adId: this.id,
      };
      this.$axios.get(this.api_advertising_info, params).then((res) => {
        if (res.data) {
          res.data.lastModifiedDate = formatDate(res.data.lastModifiedDate);
          this.infoData = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.advertisement-details-page {
  background: white;

  .cts {
    padding: 20px;

    .title {}
    .time{
      font-size: 16px;
      margin: 20px 0;
    }
   
  }

}
</style>
<style lang="scss">
.adText {
  font-size: 18px;
  line-height: 30px;
  text-align: justify;
  //line-break: normal; 
  //word-break:break-all;
  img {
    width: 100% !important;
    height: auto !important;
    display: block;
    margin: 5px 0;

  }
}

/* 组件全局css类调整 */
.advertisement-details-page {
  .content {
    p {
      font-size: 0.48rem;
      color: #262833;
      text-align: left;
    }

    p {
      img {
        padding: 20px 0px;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
